module.exports = __webpack_public_path__ + "static/media/mta-live-events.6089b65a.png";